import { LocalizationProvider, PickersDayProps } from '@mui/x-date-pickers';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { DateTime } from 'luxon';
import React, { FunctionComponent } from 'react';
import { StartsOnSundayLuxonAdapter } from '../MoDatePickerField';
import { AvailabilityProps, CalendarDay } from './CalendarDay';

export type MoSelectAvailableDateCalendarProps = AvailabilityProps & {
  onChange: (value: DateTime) => void;
  value: DateTime | null;
  minDate?: DateTime;
  maxDate?: DateTime;
};

export const MoSelectAvailableDateCalendar: FunctionComponent<MoSelectAvailableDateCalendarProps> = ({
  onChange = () => {},
  value,
  minDate,
  maxDate,
  ...availability
}) => (
  <LocalizationProvider dateAdapter={StartsOnSundayLuxonAdapter} adapterLocale="en-us">
    <DateCalendar
      slots={{
        day: (dayProps: PickersDayProps<DateTime>) => (
          <CalendarDay {...dayProps} {...availability} />
        ),
      }}
      onChange={(value) => {
        if (!value) {
          return;
        }

        onChange(value);
      }}
      value={value}
      minDate={minDate}
      maxDate={maxDate}
    />
  </LocalizationProvider>
);
